import { render, staticRenderFns } from "./cadastrar-emolumentos.vue?vue&type=template&id=35277ed2&"
import script from "./cadastrar-emolumentos.vue?vue&type=script&lang=js&"
export * from "./cadastrar-emolumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports